export class EmprezChatMessage{
  body:string;
  fromName: string;
  channelName: string;
  chatChannelId: string;


}
